import {
  NumberUtils,
  extractLastNameComponent,
  formatDateRange as formatDateRangeCore,
} from '@spotify/confidence-core-react';

export const resolveDisplayName = (entity: {
  name: string;
  displayName?: string | null;
}): string =>
  entity.displayName || extractLastNameComponent(entity.name) || entity.name;

export const formatAllocation = (proportion: unknown): string | undefined => {
  if (typeof proportion !== 'string' && typeof proportion !== 'number') {
    return undefined;
  }
  const value = Number(proportion);
  if (!Number.isFinite(value)) return undefined;
  const formatted = NumberUtils.formatPercentage(value);
  return formatted === '-' ? undefined : formatted;
};

export const formatCriteriaCount = (count: number): string =>
  `${count} user criteri${count === 1 ? 'on' : 'a'}`;

const formatSingleDate = (dateStr: string): string | undefined => {
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return undefined;
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatDateRange = (
  start?: string | null,
  end?: string | null,
): string | undefined => {
  if (!start && !end) return undefined;
  if (start && end) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
      return undefined;
    }
    return formatDateRangeCore(startDate, endDate);
  }
  const single = formatSingleDate(start ?? end ?? '');
  if (!single) return undefined;
  return start ? `From ${single}` : `Until ${single}`;
};
